import React, { useState } from "react";
import { showError, showSuccess } from "../../utils/toastUtils";
import userAPI from "../../api/UserApi";
import { Lock, Check } from "lucide-react";

function ChangePassword() {
  const [currentPassword,  setCurrentPassword]  = useState("");
  const [newPassword,      setNewPassword]       = useState("");
  const [confirmPassword,  setConfirmPassword]   = useState("");
  const [errors,           setErrors]            = useState({});
  const [saved,            setSaved]             = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!currentPassword) {
      newErrors.currentPassword = "Please Enter Current Password";
    } else if (currentPassword.length < 6) {
      newErrors.currentPassword = "Current Password must be at least 6 characters";
    }

    if (!newPassword) {
      newErrors.newPassword = "Please Enter New Password";
    } else if (newPassword.length <= 6) {
      newErrors.newPassword = "New Password must be more than 6 characters";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Please Enter Confirm Password";
    } else if (confirmPassword.length <= 6) {
      newErrors.confirmPassword = "Confirm Password must be more than 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDetailsSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = { newPassword, currentPassword, confirmPassword };

    try {
      const res = await userAPI.updatePassword(payload);
      if (res.code === 200) {
        showSuccess(res.message);
        setSaved(true);
        setTimeout(() => setSaved(false), 2600);
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <div>
      <p className="vp-eyebrow">Security</p>
      <h2 className="vp-title">Change Password</h2>
      <div className="vp-rule" />

      <div className="row">
        <div className="col-lg-7">
          <div className="vp-block">
            <p className="vp-block-title">Update Password</p>

            <div className="row g-3">
              {/* Current Password */}
              <div className="col-12">
                <label className="vp-label">Current Password</label>
                <div className="vp-icon-wrap">
                  <Lock size={13} />
                  <input
                    className="vp-input"
                    type="password"
                    placeholder="••••••••"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                  />
                </div>
                {errors.currentPassword && (
                  <p className="vp-error">{errors.currentPassword}</p>
                )}
              </div>

              {/* New Password */}
              <div className="col-md-6">
                <label className="vp-label">New Password</label>
                <div className="vp-icon-wrap">
                  <Lock size={13} />
                  <input
                    className="vp-input"
                    type="password"
                    placeholder="••••••••"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>
                {errors.newPassword && (
                  <p className="vp-error">{errors.newPassword}</p>
                )}
              </div>

              {/* Confirm Password */}
              <div className="col-md-6">
                <label className="vp-label">Confirm Password</label>
                <div className="vp-icon-wrap">
                  <Lock size={13} />
                  <input
                    className="vp-input"
                    type="password"
                    placeholder="••••••••"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                {errors.confirmPassword && (
                  <p className="vp-error">{errors.confirmPassword}</p>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center mt-4">
              <button className="vp-btn-outline" onClick={handleDetailsSubmit}>
                Update Password
              </button>
              {saved && (
                <span className="vp-success">
                  <Check size={13} /> Updated
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;